var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.price)?_c('span',{staticClass:"price-label float-right"},[(_vm.price == 0)?_c('span',[_vm._v("\n    免费\n  ")]):_vm._e(),(_vm.price > 0)?_c('span',[_vm._v(" $"+_vm._s(_vm.formatPrice(_vm.price))+" ")]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }